// Galaxy speed (decision log G-40). Every duration is divided by speed_pct/100 and every per-hour
// rate multiplied by it. The combat round interval is the one exception and never goes through here.
import type { Balance } from './schema.js';

export const MS_PER_HOUR = 3_600_000;

export interface GalaxySpeed {
  readonly speedPct: number;
  /** A balance duration in milliseconds, scaled to this galaxy (rounded down to whole ms). */
  durationMs(ms: number): number;
  /** A per-hour rate (e.g. milli-units per hour), scaled to this galaxy (rounded down). */
  ratePerH(ratePerH: bigint): bigint;
}

export function galaxySpeed(speedPct: number): GalaxySpeed {
  if (!Number.isInteger(speedPct) || speedPct <= 0) {
    throw new RangeError(`speed_pct must be a positive integer, got ${speedPct}`);
  }
  const factor = BigInt(speedPct);
  return {
    speedPct,
    durationMs: (ms) => Math.floor((ms * 100) / speedPct),
    ratePerH: (ratePerH) => (ratePerH * factor) / 100n,
  };
}

/** The round interval of new galaxies. Deliberately independent of the galaxy speed (G-40). */
export function roundIntervalS(balance: Balance): number {
  return balance.combat.round_interval_s.default;
}

/** Galaxy speeds run from the live speed up to `galaxy.speed_pct.test_max`. */
export function assertSpeedPct(balance: Balance, speedPct: number): void {
  const { live, test_max } = balance.galaxy.speed_pct;
  if (!Number.isInteger(speedPct) || speedPct < live || speedPct > test_max) {
    throw new RangeError(`speed_pct must be a whole number from ${live} to ${test_max}`);
  }
}
